import React, { useEffect, useState } from 'react';
import { Table, Form, Badge, Pagination, Spinner, Card } from 'react-bootstrap';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { creditAPI } from '../services/api';
import { toast } from 'react-toastify';

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => { fetchTransactions(); }, [page, search, filter]);

  const fetchTransactions = async () => {
    try {
      const response = await creditAPI.getTransactions({ page, search, type: filter !== 'all' ? filter : undefined });
      setTransactions(response.data.data);
      setTotalPages(response.data.pagination.pages);
    } catch (error) { toast.error('Failed to load transactions'); }
    finally { setLoading(false); }
  };

  const getTypeBadge = (type) => {
    const variants = { add: 'success', remove: 'danger', purchase: 'info', usage: 'warning' };
    return <Badge bg={variants[type] || 'secondary'}>{type}</Badge>;
  };

  const getAmountDisplay = (amount, type) => {
    const isPositive = ['add', 'purchase'].includes(type);
    return (
      <span className={isPositive ? 'text-success' : 'text-danger'}>
        {isPositive ? <FaArrowUp /> : <FaArrowDown />} {Math.abs(amount)}
      </span>
    );
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Credit Transactions</h3>
        <Form.Select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ width: '200px' }}>
          <option value="all">All Types</option>
          <option value="add">Credits Added</option>
          <option value="remove">Credits Removed</option>
          <option value="purchase">Purchases</option>
          <option value="usage">Usage</option>
        </Form.Select>
      </div>

      <Form.Control type="text" placeholder="Search transactions..." value={search} onChange={(e) => setSearch(e.target.value)} className="mb-3" />

      <Card>
        <Card.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr><th>Date</th><th>User</th><th>Type</th><th>Amount</th><th>Package</th><th>Notes</th></tr>
            </thead>
            <tbody>
              {transactions.map((tx) => (
                <tr key={tx.id}>
                  <td>{new Date(tx.created_at).toLocaleString()}</td>
                  <td>{tx.recipient?.name || 'System'}</td>
                  <td>{getTypeBadge(tx.transaction_type)}</td>
                  <td><strong>{getAmountDisplay(tx.amount, tx.transaction_type)}</strong></td>
                  <td>{tx.package_name || '-'}</td>
                  <td>{tx.notes}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Pagination className="mt-3">{[...Array(totalPages)].map((_, i) => (
        <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => setPage(i + 1)}>{i + 1}</Pagination.Item>
      ))}</Pagination>
    </div>
  );
};

export default Transactions;
